module.exports = __webpack_public_path__ + "static/img/3areaB_15.fe9422a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_15.png
// module id = 1157
// module chunks = 1